import { NavLink } from 'react-router-dom';

import {
  resolveNotificationNavPresentation,
  resolveUnreadBadge,
} from '../../features/notifications/lib/unreadBadge';

const NAV_LINK_END_PATHS = new Set(['/', '/feed', '/profile']);

function resolveNavItemBadge(item) {
  if (item.badgeKey === 'unreadNotifications') {
    return resolveNotificationNavPresentation(item.label, item.badge);
  }
  if (item.badge) {
    return {
      linkAriaLabel: item.label,
      badge: {
        display: String(item.badge),
        ariaLabel: `${item.badge} непрочитаних`,
      },
    };
  }
  return {
    linkAriaLabel: item.label,
    badge: null,
  };
}

function NavItem({ item, userImage }) {
  const computeClassName = ({ isActive }) =>
    [
      'p-nav-item',
      isActive ? 'active' : '',
      item.extraClassName ?? '',
    ]
      .filter(Boolean)
      .join(' ');

  const iconNode =
    item.avatarKey === 'userImage' && userImage ? (
      <span className="profile-logo">
        <img src={userImage} alt="" aria-hidden="true" />
      </span>
    ) : (
      <i className={item.iconClass} aria-hidden="true" />
    );

  const { linkAriaLabel, badge } = resolveNavItemBadge(item);
  const isNotificationBadge = item.badgeKey === 'unreadNotifications';

  return (
    <NavLink
      to={item.to}
      end={NAV_LINK_END_PATHS.has(item.to)}
      className={computeClassName}
      title={item.label}
      aria-label={linkAriaLabel}
    >
      <span className="nav-text">
        <span className="nav-icon-anchor">
          {iconNode}
          {badge ? (
            <span
              className="pmb-badge"
              aria-hidden={isNotificationBadge ? 'true' : undefined}
              aria-label={isNotificationBadge ? undefined : badge.ariaLabel}
              data-unread-count={
                isNotificationBadge ? String(normalizeCount(item.badge)) : undefined
              }
            >
              {badge.display}
            </span>
          ) : null}
        </span>
        <strong>{item.label}</strong>
      </span>
    </NavLink>
  );
}

function normalizeCount(count) {
  const resolved = resolveUnreadBadge(count);
  return resolved ? resolved.count : 0;
}

export default NavItem;
